var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 569.18 371.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-46{fill:#344563;}.cls-1{opacity:0.1;}.cls-1,.cls-17,.cls-18,.cls-2{isolation:isolate;}.cls-2{opacity:0.05;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#c1c7d0;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:#ff7143;}.cls-11{fill:#0065ff;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-34,.cls-53{fill:none;}.cls-12{stroke:#ebecf0;}.cls-12,.cls-13,.cls-14,.cls-15,.cls-53{stroke-miterlimit:10;}.cls-12,.cls-13,.cls-14,.cls-15{stroke-width:3.59px;}.cls-13{stroke:url(#linear-gradient-7);}.cls-14{stroke:url(#linear-gradient-8);}.cls-15{stroke:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17,.cls-18{opacity:0.7;}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:#ff8f73;}.cls-20{fill:#ffc400;}.cls-21{fill:#ffe380;}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:#fff;}.cls-24{fill:#ffab00;}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:#2684ff;}.cls-27{fill:#4c9aff;}.cls-28{fill:#ff991f;}.cls-29{fill:url(#linear-gradient-15);}.cls-30{fill:url(#linear-gradient-16);}.cls-31{fill:#8c715d;}.cls-32{fill:#162b4c;}.cls-33{fill:#8893a5;}.cls-35{fill:#27375c;}.cls-36{fill:#ff5630;}.cls-37{fill:#ff7452;}.cls-38{opacity:0.2;fill:url(#linear-gradient-17);}.cls-39{fill:#ecc19c;}.cls-40{fill:url(#linear-gradient-18);}.cls-41{fill:#253858;}.cls-42{fill:url(#linear-gradient-19);}.cls-43{fill:url(#linear-gradient-20);}.cls-44{fill:#926d5a;}.cls-45{fill:url(#linear-gradient-21);}.cls-47{fill:url(#linear-gradient-22);}.cls-48{fill:#172b4d;}.cls-49{fill:#f1dad5;}.cls-50{fill:url(#linear-gradient-23);}.cls-51{fill:#505f79;}.cls-52{opacity:0.7;}.cls-53{stroke:#0065ff;stroke-width:2.36px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 127.28,
    y1: 2561.29,
    x2: 534.92,
    y2: 2561.29,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f7f8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#eeeff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ebecf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 131.22,
    y1: 2398.51,
    x2: 435.36,
    y2: 2702.65,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c1c7d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 96.53,
    y1: 2389.2,
    x2: 419.29,
    y2: 2711.96,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cfd4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f8f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 232.54,
    y1: 2392.34,
    x2: 232.54,
    y2: 2708.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebecf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ebecf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ebecf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2551.85,
    y1: 2377.42,
    x2: 2202.51,
    y2: 2726.76,
    gradientTransform: "translate(2602.63 2732.97) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f0f2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2570.74,
    y1: 2386.85,
    x2: 2221.88,
    y2: 2735.71,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 318.27,
    y1: 2696.76,
    x2: 342.42,
    y2: 2696.76,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e5e8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e5e8ec",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e4e7eb",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e3e6ea",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e1e4e9",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#dee2e7",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#dbdfe5",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#d8dce2",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#d4d8df",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4db",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4db",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 216.64,
    y1: 2696.76,
    x2: 240.79,
    y2: 2696.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 115.03,
    y1: 2696.76,
    x2: 139.18,
    y2: 2696.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 46.55,
    y1: 2538.14,
    x2: 343.64,
    y2: 2538.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 123.8,
    y1: 2498.55,
    x2: 182.51,
    y2: 2498.55,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 316.72,
    y1: 2608.53,
    x2: 356.44,
    y2: 2608.53,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 370.83,
    y1: 2620.68,
    x2: 399.85,
    y2: 2620.68,
    gradientTransform: "matrix(0.99, -0.14, -0.14, -0.99, 188.86, 2886.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -263.46,
    y1: 1594.88,
    x2: -234.46,
    y2: 1594.88,
    gradientTransform: "matrix(0.71, 0.7, 0.7, -0.71, -629.56, 1489.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 286.57,
    y1: 2619.29,
    x2: 304.85,
    y2: 2619.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 48.65,
    y1: 2376.57,
    x2: 66.94,
    y2: 2376.57,
    gradientTransform: "matrix(0.97, 0.22, 0.22, -0.97, -272.17, 2417.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 269.51,
    y1: 2505.74,
    x2: 269.51,
    y2: 2580.71,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafbfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7a869a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 254.27,
    y1: 2514.95,
    x2: 254.27,
    y2: 2580.7,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0569ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1f7bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3389ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#4192ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4a98ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9aff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 215.29,
    y1: 2589.9,
    x2: 249.73,
    y2: 2589.9,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ebecef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e2e4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dfe1e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 419.51,
    y1: 2438.34,
    x2: 434.7,
    y2: 2398.96,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4c9aff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 400.31,
    y1: 2382.02,
    x2: 400.31,
    y2: 2461.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c9aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 391.63,
    y1: 2454,
    x2: 391.63,
    y2: 2543.43,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2732.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2333.82,
    y1: 2490.13,
    x2: 2342.17,
    y2: 2490.13,
    gradientTransform: "translate(2565.42 2732.97) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f1dbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efc7b0"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Scheduling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 240.23,
    cy: 355.7,
    rx: 34.47,
    ry: 5.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 42.5,
    cy: 357,
    rx: 40.02,
    ry: 6.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 405.28,
    cy: 363.53,
    rx: 46.53,
    ry: 7.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.31,314.35H215.2L51.62,340.63H494.75l71.14-18.57a3.88,3.88,0,0,0-.58-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.39,319.22h306a4.3,4.3,0,0,0,4.33-5.67L443.41,28.1a5.91,5.91,0,0,0-5.55-3.94h-306a4.31,4.31,0,0,0-4.37,5.68l91.31,285.44A5.92,5.92,0,0,0,224.39,319.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.61,340.63h306a5.16,5.16,0,0,0,5.19-5.13,6.09,6.09,0,0,0-.08-.95L438.8,28.39a5.14,5.14,0,0,0-5.08-4.23h-306a5.14,5.14,0,0,0-5.16,5.15,5,5,0,0,0,.08.94L178.52,336.4A5.17,5.17,0,0,0,183.61,340.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": " Path ",
    className: "cls-5",
    d: "M445.66,340.63H139.53a5.14,5.14,0,0,1-5.15-4.84L115.76,29.64a5.15,5.15,0,0,1,4.82-5.47H427A5.15,5.15,0,0,1,432.2,29l18.62,306.15a5.16,5.16,0,0,1-4.83,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": " Path 2",
    className: "cls-6",
    d: "M401.67,340.63H95.53a5.16,5.16,0,0,1-5.17-5.15c0-.11,0-.22,0-.33L109,29a5.16,5.16,0,0,1,5.16-4.84H420.29a5.15,5.15,0,0,1,5.16,5.14c0,.12,0,.23,0,.34L406.81,335.77A5.14,5.14,0,0,1,401.67,340.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": " Path 3",
    className: "cls-7",
    d: "M357.59,340.63h-306a5.15,5.15,0,0,1-5.16-5.15,4.87,4.87,0,0,1,.08-.93l55.8-306.16a5.16,5.16,0,0,1,5.08-4.23h306a5.14,5.14,0,0,1,5.16,5.15,4.27,4.27,0,0,1-.08.94L362.67,336.4A5.17,5.17,0,0,1,357.59,340.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M418.53,30.25a5.15,5.15,0,0,0-3.21-5.79L118.47,33.59a5.93,5.93,0,0,0-5.56,3.95l-28.35,88.6L47.61,328.67H331.94a5.91,5.91,0,0,0,5.55-3.94L414.66,51.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": " Path 4",
    className: "cls-9",
    d: "M313.05,319.22H7.07a4.3,4.3,0,0,1-4.58-4,4.2,4.2,0,0,1,.21-1.65L94,28.1a5.92,5.92,0,0,1,5.56-3.94h306a4.33,4.33,0,0,1,4.37,5.68L318.62,315.28A5.9,5.9,0,0,1,313.05,319.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M405.57,24.16h-306A5.93,5.93,0,0,0,94,28.1L80.53,70.34H397l12.95-40.48a4.32,4.32,0,0,0-2.68-5.48A4.22,4.22,0,0,0,405.57,24.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 342.41,
    cy: 46.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M320.06,24.15a22.35,22.35,0,1,1,44.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M342.42,46.5a22.35,22.35,0,0,1-22.35-22.35"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 240.79,
    cy: 46.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M218.45,24.15a22.35,22.35,0,1,1,44.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.79,46.5a22.35,22.35,0,0,1-22.35-22.35h0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 139.18,
    cy: 46.5,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.79,24.15a22.36,22.36,0,1,1,44.71,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M139.18,46.5a22.36,22.36,0,0,1-22.39-22.32v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M342.7,135.41l.94-2.92H292.26l13-40.35h-2.92l-13,40.35H251.67l13-40.35h-2.93l-13,40.35H211.09l13-40.35h-2.92l-13,40.35H170.5l13-40.35h-2.92l-13,40.35H129.91l13-40.35H140l-13,40.35H86.64l-1,2.92H126l-12.11,37.66H73.59L72.65,176H113l-12.1,37.67H60.54l-.94,2.92H99.94l-12.1,37.67H47.49l-.94,2.92H86.9l-13,40.35h2.92l13-40.35h37.65l-13,40.35h2.93l13-40.35h37.65l-13,40.35H158l13-40.35h37.65l-12.92,40.35h2.92l13-40.35h37.66l-13,40.35h2.92l13-40.35h51.34l.94-2.92H253.11l12.11-37.66h51.37l.94-2.92H266.16L278.26,176h51.38l.94-2.92H279.21l12.08-37.68Zm-94.89,0-12.09,37.66H198l12.13-37.66ZM197.1,176h37.65l-12.1,37.66H185Zm-15,37.66H144.4L156.51,176h37.65Zm25.16-78.25-12.1,37.66H157.45l12.1-37.66Zm-78.24,0h37.65l-12.1,37.66H116.86Zm-13,40.59h37.65l-12.11,37.66H103.81ZM90.76,254.25l12.11-37.66h37.65l-12.1,37.66Zm40.59,0,12.12-37.67h37.65L169,254.25Zm40.59,0,12.11-37.66H221.7l-12.1,37.66Zm78.25,0H212.52l12.08-37.67h37.66Zm13.05-40.59H225.57L237.67,176h37.66Zm13.05-40.59H238.62l12.1-37.66h37.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M156.56,188.43l-1.42,2.47a1.52,1.52,0,0,0,.56,2.08h0l12.38,6.83A48.7,48.7,0,0,0,148.53,208c-21.92,14.88-23.91,65.51-24.71,71.13a1.51,1.51,0,0,0,1.28,1.72h.09l3.76.34a1.52,1.52,0,0,0,1.64-1.29c.69-4.73,4.12-53.47,22.11-66.6A38,38,0,0,1,173,206.08L161.25,221a1.53,1.53,0,0,0,.27,2.14h0l2.31,1.73a1.51,1.51,0,0,0,2.11-.28l16-20.36a2.63,2.63,0,0,0-.8-3.94l-22.54-12.44A1.53,1.53,0,0,0,156.56,188.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M351.39,155.09l.34-3.34a1.76,1.76,0,0,0-1.57-1.94h0l-16.46-1.41a49.74,49.74,0,0,0,17-18c8.48-15.51,5.73-30.62,3.93-36.94a1.77,1.77,0,0,0-2.18-1.22.17.17,0,0,0-.1,0l-4.18,1.43A1.76,1.76,0,0,0,347,95.83a41.58,41.58,0,0,1-3.34,30.94,42.45,42.45,0,0,1-18.18,17.32l5.42-21.53a1.76,1.76,0,0,0-1.28-2.14h0l-3.33-.76a1.77,1.77,0,0,0-2.11,1.29l-7.3,29.34a3.1,3.1,0,0,0,2.26,3.75,3.55,3.55,0,0,0,.47.08l29.9,2.61a1.78,1.78,0,0,0,1.91-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M247.51,237.67a46.36,46.36,0,0,1-36.68-17.79,40.1,40.1,0,0,1-7.52-34.06c3.24-13.94,13.59-26.81,28.39-35.31,14.38-8.26,30.09-10.66,41-6.26,6.56,2.64,11.76,7.85,15.45,15.47L282,163.3c-3.07-6.34-7.28-10.63-12.51-12.73-9-3.61-22.7-1.37-35,5.68-12.85,7.38-21.79,18.4-24.54,30.22a34.07,34.07,0,0,0,6.51,28.9,40.48,40.48,0,0,0,32,15.56h0c19.88,0,44.95-17.25,50.76-45,5.06-24.2-9.11-46.69-33-52.24l2.38-6.59c27,6.31,43,31.81,37.23,59.3-5.15,24.66-28.89,51.27-58.31,51.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M313.19,263.86l-10.28-3.41a.94.94,0,0,0-1.19.59l-4.05,11.88a.94.94,0,0,0,.59,1.2h0l1.79.61a.94.94,0,0,0,1.2-.58h0l2-6,10.45,27.11a1,1,0,0,0,1.21.54l1.77-.66a1,1,0,0,0,.55-1.22h0l-10.91-28.29,5.63,1.86a.94.94,0,0,0,1.19-.6l.6-1.79a1,1,0,0,0-.59-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M286.6,245.55l-9.61-5a.94.94,0,0,0-1.27.4l-5.86,11.11a1,1,0,0,0,.4,1.28h0l1.67.88a1,1,0,0,0,1.28-.4h0l3-5.64L279.51,264a.94.94,0,0,0,1.11.73l1.85-.39a1,1,0,0,0,.73-1.11l-3.56-17.07,5.26,2.72a.94.94,0,0,0,1.28-.39h0l.87-1.68a.94.94,0,0,0-.43-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M311.71,222.3l-10.79,1a1,1,0,0,0-.86,1l1.05,12.51a.94.94,0,0,0,1,.87h0l1.88-.16a.93.93,0,0,0,.86-1h0l-.53-6.35,11.29,11.56a1,1,0,0,0,1.34,0l1.35-1.32a.94.94,0,0,0,0-1.33L306.1,226.57,312,226a.93.93,0,0,0,.85-1l-.16-1.88A.94.94,0,0,0,311.71,222.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M178.67,180.7l8-7.32a1,1,0,0,0,.06-1.33l-8.42-9.32a1,1,0,0,0-1.33-.06l-1.4,1.26a1,1,0,0,0-.07,1.34l4.27,4.72-16-2.34a.94.94,0,0,0-1.1.75v0l-.27,1.86a1,1,0,0,0,.75,1.11h.05L180.45,174l-4.37,4a1,1,0,0,0-.06,1.33l1.28,1.39a1,1,0,0,0,1.34.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M190.29,162.39l10.75-1.3a.94.94,0,0,0,.82-1.05l-1.41-12.47a.94.94,0,0,0-1-.83h0l-1.88.21a.94.94,0,0,0-.83,1h0l.71,6.33-25.9-25.49a1,1,0,0,0-1.34,0h0l-1.32,1.36a1,1,0,0,0,0,1.33l26.86,26.41-5.88.71a1,1,0,0,0-.83,1.06h0l.23,1.88a1,1,0,0,0,1.06.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M204.6,247.18a4.46,4.46,0,0,1-2.15.49l-4.55-.12-3.08,3.95A5.29,5.29,0,0,1,193,253a4.22,4.22,0,0,1-3.79.09,4,4,0,0,1-2.22-3l-.84-4.68-4.19-1.5a4.1,4.1,0,0,1-2.65-3.86,5.4,5.4,0,0,1,2.34-4.62l4.05-2.78.49-4.89a5.42,5.42,0,0,1,2.92-4.29,4.07,4.07,0,0,1,4.64.49l3.34,3,4.44-1.53a4,4,0,0,1,4.45,1.2,4.78,4.78,0,0,1,.52,4.93l-1.94,4.62,2.29,3.95a4.81,4.81,0,0,1,.33,3.94A5.46,5.46,0,0,1,204.6,247.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M205.13,244.25a4.67,4.67,0,0,1-2.14.49l-4.56-.13-3.08,4a5.31,5.31,0,0,1-1.78,1.48,4.25,4.25,0,0,1-3.79.09,4.1,4.1,0,0,1-2.22-3l-.83-4.68-4.19-1.5a4.11,4.11,0,0,1-2.66-3.86,5.43,5.43,0,0,1,2.34-4.62l4.05-2.78.49-4.89a5.4,5.4,0,0,1,2.92-4.29,4.08,4.08,0,0,1,4.65.48l3.33,3,4.45-1.52a4,4,0,0,1,4.44,1.2,4.78,4.78,0,0,1,.53,4.92l-2,4.62,2.29,3.94a4.83,4.83,0,0,1,.33,3.95A5.47,5.47,0,0,1,205.13,244.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M192.51,223.28l4.35,3.88,5.88-2a1.7,1.7,0,0,1,2.14,1.08,1.67,1.67,0,0,1-.15,1.38l-2.6,6,3,5.16a2.09,2.09,0,0,1-.92,2.81,2,2,0,0,1-.87.23l-6-.16-4,5.18a1.68,1.68,0,0,1-2.32.56,1.71,1.71,0,0,1-.78-1.14l-1.11-6.12-5.49-2a1.92,1.92,0,0,1-.86-2.59,1.94,1.94,0,0,1,.73-.8l5.3-3.63.64-6.39a1.93,1.93,0,0,1,2-1.89A2,2,0,0,1,192.51,223.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M315.54,196.32a4.67,4.67,0,0,1-1.68-1.41l-2.64-3.74-5-.07a5.42,5.42,0,0,1-2.23-.54,4.22,4.22,0,0,1-2.34-3,4.07,4.07,0,0,1,1.11-3.56l3.25-3.48-1.37-4.25a4.11,4.11,0,0,1,1.48-4.44,5.41,5.41,0,0,1,5.11-.9l4.65,1.55,4.2-2.54a5.44,5.44,0,0,1,5.18-.25,4.1,4.1,0,0,1,2.4,4l-.37,4.44,3.91,2.68a4,4,0,0,1,1.72,4.28,4.74,4.74,0,0,1-3.62,3.33l-4.88,1.19-1.78,4.2a4.83,4.83,0,0,1-2.94,2.64A5.48,5.48,0,0,1,315.54,196.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M318.21,195a4.59,4.59,0,0,1-1.68-1.41l-2.64-3.72-5-.07a5.34,5.34,0,0,1-2.22-.54,4.21,4.21,0,0,1-2.34-3,4,4,0,0,1,1.11-3.55l3.24-3.48L307.34,175a4.11,4.11,0,0,1,1.48-4.44,5.41,5.41,0,0,1,5.11-.9l4.65,1.55,4.2-2.54a5.42,5.42,0,0,1,5.18-.25,4.08,4.08,0,0,1,2.4,4l-.37,4.45,3.91,2.68a4,4,0,0,1,1.73,4.28,4.79,4.79,0,0,1-3.63,3.33l-4.88,1.19-1.77,4.2a4.88,4.88,0,0,1-3,2.64A5.49,5.49,0,0,1,318.21,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M327.36,172.28l-.48,5.81,5.12,3.5a1.69,1.69,0,0,1,.43,2.35,1.67,1.67,0,0,1-1.18.72l-6.38,1.56-2.33,5.55a2.08,2.08,0,0,1-3.5.39l-3.46-4.85-6.56-.1a1.69,1.69,0,0,1-1.85-1.52,1.67,1.67,0,0,1,.44-1.31l4.24-4.55-1.73-5.56c-.43-1.38,1.11-2.65,2.63-2.13l6.08,2,5.49-3.33a1.91,1.91,0,0,1,2.68.45A2,2,0,0,1,327.36,172.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": " Path 5",
    className: "cls-27",
    d: "M112.53,284.69l1,1.49,7.33-4.93-1.35-2a17.71,17.71,0,0,1-2.92-11.69V267a17.65,17.65,0,0,0-2.91-11.69L24.77,123.07A13.54,13.54,0,0,0,6,119.39H6A13.53,13.53,0,0,0,2.3,138.17L90.91,269.9a17.65,17.65,0,0,0,10.81,7.39h0A17.69,17.69,0,0,1,112.53,284.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M57.61,220.35c.14-7.29.9-17,1.48-24.45.6-7.78,1.11-14.32,1.34-19.86l-6.91-10.28c.07,8.47-.9,20.94-1.58,29.58-.44,5.7-.81,10.67-1.11,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M27.88,127.64c-1.5,39.33,2,48.39,8,49.56,5.39,1.05,9.16-5.35,13.14-12.12.54-.92,1.21-2.06,1.9-3.17l-4.35-6.46c-1.23,1.76-2.46,3.83-3.73,6-1.45,2.45-3.95,6.73-5.56,8.25-1-2-2.88-8.79-2.51-31.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M72.88,194.51C66.7,210.27,62.6,219,59.94,223.8l4.45,6.55c3.2-5,7.41-13.73,13.34-28.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M120.74,291.21,123,288a1.31,1.31,0,0,0,0-1.49l-3.08-4.58-5.23,3.53,3.88,5.76a1.31,1.31,0,0,0,1.83.39A1.34,1.34,0,0,0,120.74,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": " Path 6",
    className: "cls-24",
    d: "M326.27,234.52l-1.37,1.11,5.41,6.76,1.86-1.49a17.34,17.34,0,0,1,11.17-3.8h.5A17.34,17.34,0,0,0,355,233.3l121.73-97.54a13.25,13.25,0,0,0,2.06-18.62h0a13.25,13.25,0,0,0-18.62-2.06h0L338.93,212.29a17.36,17.36,0,0,0-6.34,11.12h0A17.29,17.29,0,0,1,326.27,234.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M384.55,175.7c7.13-.45,16.67-.52,24-.56,7.61,0,14.06-.13,19.48-.31l9.47-7.6c-8.26.76-20.5.84-29,.89-5.55,0-10.48.08-14.71.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M472.57,139.14c-38.49,1.75-47.05,5.89-47.69,11.86-.58,5.34,6,8.49,12.9,11.82.94.46,2.1,1,3.25,1.59l5.94-4.77a69,69,0,0,0-6.16-3.15c-2.51-1.2-6.88-3.34-8.5-4.74,1.86-1.11,8.35-3.53,30.81-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M411,188.5c-15.88-4.75-24.72-8-29.63-10.23l-6,4.84c5.14,2.71,14,6.1,29,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M320.6,243.1l3.33,1.94a1.3,1.3,0,0,0,1.46-.12l4.22-3.33-3.86-4.85L320.43,241a1.3,1.3,0,0,0-.16,1.82A1.12,1.12,0,0,0,320.6,243.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M298.17,123.7a6.35,6.35,0,0,0-1.32-1.51,5,5,0,0,0,2.8-3.17l5-17.18a6.12,6.12,0,0,0-11.74-3.43,5.88,5.88,0,0,0-.18.81L290,116.91a4.94,4.94,0,0,0,1.23,4,6.33,6.33,0,0,0-4.5,4.77,6.26,6.26,0,0,0,4.74,7.48h0l.58.1a6.28,6.28,0,0,0,6.13-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M314.51,124.22a6.48,6.48,0,0,0-1-1.77A4.94,4.94,0,0,0,317,120l8.66-15.65a6.11,6.11,0,1,0-11-5.22l-6.57,16.68a5,5,0,0,0,.29,4.22,6.37,6.37,0,0,0-5.46,3.65,6.26,6.26,0,0,0,3,8.34h0l.55.22a6.29,6.29,0,0,0,8.12-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M45.91,195.93a4,4,0,0,1-.28,2.08c-.46,1.11-1.9,4.45-3,4.25-.54-.13-.77-1-.82-1.5-.08-.92,1.05-1.46,1.12-2.43a1.3,1.3,0,0,1,.08-.58c.1-.57.15-.88.28-.92s.51.58.91.57c.69,0,1-2.22,1.4-2.15C45.79,195.21,45.87,195.74,45.91,195.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M39.45,202.7c.9.85,3.17.4,4.27-.94a4,4,0,0,0,.72-3c-.15-1.11-.62-1.21-1-2.35-.78-2.42.39-4.44-.19-4.76-.14,0-.4,0-.92.46a.55.55,0,0,0-.41-.21c-.37,0-.58.67-.68,1a43.28,43.28,0,0,0-1.69,5.55C39.13,201,39,202.29,39.45,202.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M39.63,195a6.37,6.37,0,0,0-.16,2.42c0,3-.39,4.85-.16,4.85s.35-.58.46-.91c.91-2.67,2.32-8.3,1.5-8.56C40.85,192.65,40,193.86,39.63,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_12",
    "data-name": " Clipping Path 12",
    className: "cls-32",
    d: "M30.25,356.26l-12.12-2.58L19.78,346l3.72,1.88a5.22,5.22,0,0,0,1.44,3.63c1.54,1.48,3.64,1.05,4.74,2.69A3.61,3.61,0,0,1,30.25,356.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 23.64,
    y: 348.11,
    width: 0.84,
    height: 12.82,
    transform: "translate(-327.63 303.79) rotate(-77.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M30.25,356.26l-12.12-2.58L19.78,346l3.72,1.88a5.22,5.22,0,0,0,1.44,3.63c1.54,1.48,3.64,1.05,4.74,2.69A3.61,3.61,0,0,1,30.25,356.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_13",
    "data-name": " Clipping Path 13",
    className: "cls-32",
    d: "M82.34,355.27H68.65v-8.71l4.44.18c.46,2.87,1.56,4.05,2.42,4.58,1.93,1.21,4.18.24,5.78,1.83A3.88,3.88,0,0,1,82.34,355.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 68.38,
    y: 354.34,
    width: 14.25,
    height: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M82.34,355.27H68.65v-8.71l4.44.18c.46,2.87,1.56,4.05,2.42,4.58,1.93,1.21,4.18.24,5.78,1.83A3.88,3.88,0,0,1,82.34,355.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M55.76,249.59a7.81,7.81,0,0,1-2.65-3.72,8,8,0,0,1,12-9.13,2.73,2.73,0,0,1,3,4.45A3,3,0,0,1,68,242a11.58,11.58,0,0,1-4.81,6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M60.71,257.06a8.1,8.1,0,0,1-7.78-1.35,13.27,13.27,0,0,0,3-7.43l6.49,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M68.15,241.19a17.19,17.19,0,0,0,.12,2.87c.08.64.16,1.11.19,1.22a15.81,15.81,0,0,0,1,3.23l-1.6.25-1.5,5a16.83,16.83,0,0,1-6.52.08c-1.82-.36-3.68-.71-4.45-2.13a7.67,7.67,0,0,1-.5-1.56,8.41,8.41,0,0,0-.31-1c-.13-.4-.34-1-.62-1.63a4.71,4.71,0,0,0,2,.62,2.64,2.64,0,0,0,2-.4c.8-.76.24-2.09,1-2.45a1,1,0,0,1,1,.13c.79.6.42,2.57.42,2.57h1.43a5.76,5.76,0,0,1,.9-2.5c.78-1.11,1.48-1.11,2-2.22s.19-1.76.73-2.22S66.5,240.55,68.15,241.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M86.27,228.36a3.8,3.8,0,0,0,.4,1.93c.51,1,2.07,4.05,3.1,3.75.49-.14.65-1,.66-1.45,0-.86-1.11-1.29-1.21-2.23a2.38,2.38,0,0,0-.11-.53c-.14-.54-.19-.81-.31-.83s-.44.58-.8.59c-.65,0-1.12-2-1.46-1.9C86.38,227.7,86.28,228.19,86.27,228.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M40.61,276.45c-1.21,2.22-2.28,4.54-3.33,7a106.38,106.38,0,0,0-8,28.75c-1.43,3.34-2.82,6.83-4.14,10.55a157.88,157.88,0,0,0-6.54,25l6.5,1.49,12.46-33.8c.66-1.38,1.61-3.45,2.77-5.93,8.39-18.18,9.2-21.41,8.24-24.7C48,283,46.39,279.57,40.61,276.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M93.3,234.32c-.84.91-3.13.62-4.33-.63a4,4,0,0,1-.93-2.94c.08-1.11.53-1.21.82-2.42.61-2.42-.7-4.45-.14-4.76.13-.07.4,0,.94.4a.57.57,0,0,1,.39-.23c.37,0,.64.63.76.92a47.26,47.26,0,0,1,2.07,5.42C93.45,232.61,93.72,233.88,93.3,234.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M57.1,280.2a271.84,271.84,0,0,1,11.2,32.71A273,273,0,0,1,75.45,348H68q-1.63-7.14-3.73-14.78c-1.92-7-4-13.5-6.13-19.66-10.53-10.14-17.57-18.74-19.62-23-.79-1.63-2.22-4.51-1.21-7.27.14-.44.54-1.21,1.32-2.87s1.48-3,1.94-3.92a55.26,55.26,0,0,0,16.6,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M66.29,256.23a27.9,27.9,0,0,1-15-6.06,28.66,28.66,0,0,1-7.78-10.45,32.85,32.85,0,0,1-3-12q1.5-7.78,2.59-16.42c.35-2.72.65-5.4.89-8l-5.56-3c-1.21,4.32-2.22,8.89-3.25,13.72-1.11,5.4-2,10.58-2.67,15.47a54.26,54.26,0,0,0,5.91,19.74,53.31,53.31,0,0,0,6.84,10c-.76,2.59-1.66,5.35-2.77,8.22a104.39,104.39,0,0,1-4.59,10.11,22.63,22.63,0,0,0,20.45,5.69c.94-2.29,1.83-4.76,2.69-7.41a92.09,92.09,0,0,0,2.72-10.22,31.86,31.86,0,0,0,8.83-.24c3.11-.52,8.32-1.39,12.68-5.28,3.64-3.19,4.85-6.87,6.38-11.28a44.26,44.26,0,0,0,2.42-15.56,5,5,0,0,0-2.22-.45,5.14,5.14,0,0,0-2.83,1,55.08,55.08,0,0,1-8,20.17,23,23,0,0,1-14.75,2.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 233.91,
    y: 152.26,
    width: 71.2,
    height: 74.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M238.64,222.86l-.06-1.52-.63-1.86v-3.84a.49.49,0,0,1,.24,0c.73.28.71,1.79.71,1.86l.1-4.12a.75.75,0,0,1,.69-.1c.2.12.21.76.16,1.51a23.42,23.42,0,0,0,0,2.37l.54-4a.65.65,0,0,1,.47.12.89.89,0,0,1,.24.71c0,1-.29,3-.31,3.23l1.2-3.8a.89.89,0,0,1,.52.33c.24.34.06.77-.3,2.13-.25.93-.43,1.46-.15,1.88a1,1,0,0,0,.17.18,1.85,1.85,0,0,1,1-1.35,1.42,1.42,0,0,1,.79,0l-.29.59a13.26,13.26,0,0,0-.73,2l-.7,1.88v1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M305.92,152.27A135,135,0,0,1,274.62,218h-72a135,135,0,0,0,31.29-65.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M295.35,121.82a6.58,6.58,0,0,0-1.32-1.51,5,5,0,0,0,2.8-3.17L301.78,100a6.11,6.11,0,0,0-11.73-3.43,5.71,5.71,0,0,0-.18.82L287.18,115a4.93,4.93,0,0,0,1.22,4,6.35,6.35,0,0,0-4.5,4.77,6.27,6.27,0,0,0,4.75,7.48h0l.57.1a6.29,6.29,0,0,0,6.14-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M294.5,116.46l5-17.19a3.7,3.7,0,0,0-2.54-4.58l-.22-.06h0a3.71,3.71,0,0,0-4.4,2.83,1.85,1.85,0,0,0,0,.23l-2.69,17.68a2.53,2.53,0,0,0,2,2.86h0A2.52,2.52,0,0,0,294.5,116.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M286.25,124.35a3.84,3.84,0,0,0,2.88,4.6l.37.06a3.89,3.89,0,1,0-3.25-4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M312.86,121.72a6.29,6.29,0,0,0-.76-1.86,4.93,4.93,0,0,0,3.67-2.1L326,103.08a6.11,6.11,0,0,0-10-7,6.59,6.59,0,0,0-.44.72l-8.23,15.88a5,5,0,0,0-.15,4.22,6.37,6.37,0,0,0-5.8,3.07,6.27,6.27,0,0,0,2.09,8.6h0l.51.28a6.29,6.29,0,0,0,8.42-2.87,6.22,6.22,0,0,0,.47-4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M313.79,116.39,324,101.7a3.7,3.7,0,0,0-.92-5.15l-.19-.13h0a3.71,3.71,0,0,0-5.08,1.26,2,2,0,0,0-.11.2l-8.24,15.88a2.55,2.55,0,0,0,.94,3.34h0A2.55,2.55,0,0,0,313.79,116.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M303.43,121.15a3.83,3.83,0,0,0,1.24,5.28,3.9,3.9,0,1,0,4.06-6.65h0A3.87,3.87,0,0,0,303.43,121.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M229.54,159.22A14.45,14.45,0,0,1,218,154c-5.13-6.55-2.81-16.78,5.18-22.82a20.72,20.72,0,0,1,12.29-4.28,14.46,14.46,0,0,1,11.51,5.2c5.13,6.55,2.81,16.79-5.18,22.82A20.53,20.53,0,0,1,229.54,159.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M229.54,156A14.51,14.51,0,0,1,218,150.8c-5.13-6.55-2.81-16.79,5.18-22.82a20.59,20.59,0,0,1,12.29-4.28A14.45,14.45,0,0,1,247,128.93c5.14,6.55,2.81,16.79-5.18,22.82A20.56,20.56,0,0,1,229.54,156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M240.28,149.74c-6.67,5-15.56,4.69-19.83-.77s-2.35-14,4.32-19,15.56-4.69,19.83.76S246.94,144.71,240.28,149.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M231.38,134.84a1.53,1.53,0,0,1-2.11-.08,1.47,1.47,0,0,1,.46-2,1.53,1.53,0,0,1,2.11.08A1.47,1.47,0,0,1,231.38,134.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M239.05,144.13a1.53,1.53,0,0,1-2.11-.08,1.46,1.46,0,0,1,.46-2,1.52,1.52,0,0,1,2.11.07A1.47,1.47,0,0,1,239.05,144.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M226,137.19a7.58,7.58,0,0,0,1.23,6.67,7.92,7.92,0,0,0,6.24,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M417.57,271.5c1.29,2.44,2.55,5,3.74,7.78a118,118,0,0,1,8.78,31.88l10.34,39.46-5.76,1.65a234.55,234.55,0,0,0-13.81-37.45c-.77-1.61-1.54-3.26-3.06-6.58-9.26-20.15-10.22-23.74-9.14-27.37C409.35,278.71,411.16,274.94,417.57,271.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M360,223.64c.85.91,3.14.62,4.32-.63a4,4,0,0,0,.94-2.93c-.07-1.11-.52-1.22-.82-2.41-.6-2.43.7-4.44.14-4.76-.13-.07-.4,0-.94.4a.63.63,0,0,0-.39-.23c-.37,0-.64.62-.75.91a44.25,44.25,0,0,0-2.07,5.45C359.86,221.94,359.58,223.2,360,223.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M367,217.67a3.83,3.83,0,0,1-.4,1.94c-.5,1-2.08,4-3.1,3.75-.49-.14-.65-1-.66-1.45,0-.86,1.11-1.29,1.23-2.23a2.5,2.5,0,0,1,.11-.53c.14-.54.2-.81.33-.84s.43.57.8.58c.64,0,1.11-2,1.44-1.9S367,217.5,367,217.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M360.72,216a6.52,6.52,0,0,0-.33,2.4c-.16,3-.72,4.78-.5,4.84s.39-.56.52-.88c1.11-2.6,2.91-8.1,2.1-8.44C362.11,213.71,361.16,214.86,360.72,216Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M399.3,275.64a301.29,301.29,0,0,0-20.36,75.26l6.14.06c1.25-5,3.13-12,5.62-20.54,2-6.67,2.78-11.4,5.76-17.65a42.7,42.7,0,0,1,4.6-8.18c7.07-9.45,14.76-9.25,18.89-17.29.71-1.4,2.47-4.83,1.38-8.05-.17-.5-.6-1.4-1.47-3.19s-1.63-3.34-2.14-4.34A61.19,61.19,0,0,1,399.3,275.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M378.84,346.51a41.11,41.11,0,0,1-1.28,6.67h0a7.19,7.19,0,0,1-5.87,5.19l-5.3.79v.92l8.25,2c.75-.14,2.89-.5,3.18.16.06.14.06.39-.24.8.74.15,1.52.29,2.32.41a1.67,1.67,0,0,0,1.82-1.11c1.11-3.55,4.28-13.16,4.44-14.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M433.38,349.08c.39.78,1.11,2.84,1.82,4.92a7.91,7.91,0,0,1-2.3,8.47L430.07,365l.42.73,7.31-2.53c.51-.48,2-1.8,2.53-1.45.12.08.23.27.21.74,1-.39,2-.82,3.08-1.32l.25-.63c-.11-.32-.24-.72-.39-1.19-1.33-4.18-3.17-11.4-3.82-12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M409.6,193l-1-1.18a4.32,4.32,0,0,1-.9-3.51l.1-2.66a16,16,0,0,0,1.7-1.79c.69-.83,1-1.33,1.11-1.28s.18.68-.51,3.34a37.38,37.38,0,0,0,4.45-2.29c2-1.19,3.57-2.44,4.65-1.93.14.07.57.27.62.65s-.5.83-.54.87a.71.71,0,0,1,.61.4c.09.23-.39.87-.75,1.19-1.54,1.34-5.4,4-6.34,4.62l.2,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M389.1,249.07a164.75,164.75,0,0,0,16.67-6.77l.77-.64.17-.16.19-.17c3.42-3,6.18-9.84,6.18-9.84A112.15,112.15,0,0,0,417,220.25a61.28,61.28,0,0,1-2.85-9.27c-1.4-6.29-1.22-10.27-4-15.4a24,24,0,0,0-2.31-3.49l5.45-2.55a49.34,49.34,0,0,1,5.2,6.67,51.09,51.09,0,0,1,7.43,18.71,54.49,54.49,0,0,1-5.75,26.27,53.05,53.05,0,0,1-7.54,11.05,38.46,38.46,0,0,0,5.68,20.36L398,279c1.72-3.76,1.42-6.12.8-7.6-1.38-3.34-5.06-3.92-6.42-7.91a8.93,8.93,0,0,1-.38-4c-2.58.23-13.44.91-22.91-6.67-13.63-10.91-11.67-28.75-11.52-29.84l7.3,1.73a30.1,30.1,0,0,0,1.19,11.28C369.43,245.64,380.36,251.69,389.1,249.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M392,231.62a5.08,5.08,0,0,0,.86.19,5.89,5.89,0,0,1,2.34.81c1.24.86.42,2.52,1.49,4.94a7.79,7.79,0,0,1,.6,1.94,6.26,6.26,0,0,1,.11,1c0,.79.54,2.39,2.34,5.88l-1.11-.31-3.39-1.3c-2.44-1.63-3-1.88-3-3a35.72,35.72,0,0,0-.1-3.9c-.79-.76-1.82-.91-1-1.85.45-.53.79-.91.9-1C392.38,234.52,392.63,233.75,392,231.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M395.13,232.55a33.79,33.79,0,0,0,1.87,14l.16.44a9.89,9.89,0,0,0,12.7,5.86,10.4,10.4,0,0,0,1.55-.73l.53-.34.09-.07a6.44,6.44,0,0,0,1.58-8.95,5.56,5.56,0,0,0-.54-.66,24.56,24.56,0,0,1-3.69-5.34c-2.42-4.78-2.09-8.16-5.31-10a11.91,11.91,0,0,0-6.67-1.11,6.2,6.2,0,0,0-3.4,1,6.57,6.57,0,0,0-1.87,2.22,7.14,7.14,0,0,0-.82,2.86,10.63,10.63,0,0,1,3.8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M266.17,222.17l.51-2.06,1.37-2.36,1.11-5.25a.91.91,0,0,0-.33,0c-1.11.17-1.47,2.23-1.49,2.35l1-5.66c-.24-.2-.61-.44-.91-.33s-.5,1-.65,2a27.86,27.86,0,0,1-.64,3.25l.39-5.56a.89.89,0,0,0-.68,0,1.21,1.21,0,0,0-.51.91c-.28,1.41-.46,4.2-.48,4.44l-.58-5.55a1.33,1.33,0,0,0-.8.31c-.42.41-.29,1-.19,3,.07,1.32.19,2.12-.33,2.61a1.1,1.1,0,0,1-.28.2,2.49,2.49,0,0,0-1-2.12,2.06,2.06,0,0,0-1.11-.3c.08.28.16.58.24.89a18.67,18.67,0,0,1,.44,2.89l.43,2.78-.39,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M223.73,247.4h7.87a14.58,14.58,0,0,1-.85-8.89l-4.8-.23c-.06.28-.15.69-.29,1.18a3.2,3.2,0,0,1-.52,1.33c-.55.51-1.59.21-1.9.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": " Path 7",
    className: "cls-41",
    d: "M242.06,220.92a82,82,0,0,1,1.54,21.6,31.5,31.5,0,0,1-11.66,8.18,19.75,19.75,0,0,1-7.1,1.57c-3.81,0-9-1.11-9.21-3.08s4.53-4.44,7.91-5.37a24,24,0,0,1,3.26-.62,28.31,28.31,0,0,0,10.8-4.44l1-16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M221.15,275.87a15.43,15.43,0,0,1,1.51-4,16,16,0,0,0,1.81.46c.68.13,1.21.18,1.49.22,1.6.23,4.66.6,12.89,1.22A22.62,22.62,0,0,1,240.4,276a25.83,25.83,0,0,1,3.27,7.86,556,556,0,0,1,11.9,65.8,8.47,8.47,0,0,1-3.18,2.64c-.64.26-.61.73-1.81.85-.67-2.61-1.75-6.57-3.34-11.33-2.13-6.54-3.2-8.58-4.21-12.56a50.21,50.21,0,0,1-1.39-15.06q-2.34-4.25-4.81-8.58-2.64-4.72-5.13-9.4c.32,5.09.52,10.39.55,15.89a286.9,286.9,0,0,1-1.57,32.24,3.94,3.94,0,0,1-1.71.72,3.72,3.72,0,0,1-1.84-.2,5.33,5.33,0,0,1-2.5-1.51,107,107,0,0,1-.38-28.6,74.73,74.73,0,0,1-3.34-13s-2.53-10.43-1.11-19.77C220.07,280.49,220.88,277,221.15,275.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M268.65,358.13l-4.44-1.41a12.48,12.48,0,0,1-8.63-10.26c-.11-.86-.77-4.45-1-6a9.64,9.64,0,0,0-8,1.87,42.17,42.17,0,0,1,2.46,7.06,44.34,44.34,0,0,1,1.2,7.78c.07,1,.08,1.86.08,2.42h4.39l.73-.82,1.11.78h11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M224,337.89a7.23,7.23,0,0,1,7.91,0,27,27,0,0,0-.56,3.47c-.23,2.59-.35,4.07.56,4.87a3,3,0,0,0,2.7.47l.56.22c-2.29,2.79-4,4.91-5.05,6.34a3.64,3.64,0,0,1-1.61,1.32,2.59,2.59,0,0,1-2.36-.12,2.35,2.35,0,0,1-.89-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M232.7,231.82a8.39,8.39,0,0,0,3,5.14l-1.05,1.11-.83,4.69a12,12,0,0,1-3.34.85c-1.5.16-3.45.37-4.26-.73a3.31,3.31,0,0,1-.41-2.36,10.76,10.76,0,0,1,.32-1.94,8.76,8.76,0,0,1,1.72-2.77,12.25,12.25,0,0,1,2.83-3A9.54,9.54,0,0,1,232.7,231.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M259.84,247.39a64.9,64.9,0,0,1-21.44,8.89,67.89,67.89,0,0,0,4,19,29.48,29.48,0,0,1-21.5,1.63,48.17,48.17,0,0,0-6.11-25,24.13,24.13,0,0,1,3.33-2.64s.33-.22.83-.52c0,0,.93-.56,1.89-1,4-2,11.43-2.7,11.43-2.7,10.08-.94,9.74-.76,11.68-1.12a48.47,48.47,0,0,0,10.64-3l7-21.43,5.56,1.45c-.9,4.58-2,9.49-3.51,14.65C262.39,239.82,261.16,243.74,259.84,247.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M217.32,235.93c-3,5.46-5.1,5.17-5.64,8.46-.48,2.94.53,7.08,3.78,8.83,3.68,2,7.71-.46,7.93-.6a9.24,9.24,0,0,0,3.53-4.33c1.84-4.33-.85-6.31,1.11-9.53.76-1.29,1.54-1.56,4.38-5.25a4,4,0,0,0,.1-5.45c-1.66-2.05-4.59-1.94-5.48-1.9A9.14,9.14,0,0,0,222,228C219.36,229.94,219.59,231.82,217.32,235.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 239.45,
    y1: 173,
    x2: 284.65,
    y2: 173.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 236.36,
    y1: 180.51,
    x2: 281.55,
    y2: 180.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 233.48,
    y1: 187.5,
    x2: 268.15,
    y2: 187.66
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.b3731f566d955786935dabddf57f06ed.svg";
export { ForwardRef as ReactComponent };